import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class Story extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
      shouldReverseSplit: true,
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const paragraph = qsa(".description .line-0", this.el)

    gsap.from(paragraph, {
      y: 50,
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: paragraph,
        start: "top bottom",
      },
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
